var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{staticClass:"cursor-pointer",attrs:{"color":_vm.contactInFavorites? '#f4a259' : '#C6CFD3'},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.toggleFavorite()}}},[_vm._v(" $star ")])}
var staticRenderFns = []

export { render, staticRenderFns }